export default () => ({
  loading: false,

  addToCart(
    form,
    button,
    productImage,
    productTitle,
    productVariant,
    isExpressCheckout = false,
    showBackInStock
  ) {
    this.loading = true;

    console.log("productImage", productImage);
    if (!form || !button || button.getAttribute("aria-disabled") === "true") {
      return;
    }
    if (showBackInStock) {
      this.$dispatch("remindme", {
        title: productTitle,
        size: form.querySelector("[name='size']").value,
        id: form.querySelector("[name='id']").value,
      });
      return;
    }

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/javascript`,
      },
    };
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    let formData = new FormData(form);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => {
        this.loading = false;

        this.$dispatch("cart-updated");
        this.$dispatch("quickshop-hide");

        if (response.status == 422) {
          this.$dispatch("cart-notice-error", false);
        } else if (!isExpressCheckout) {
          this.$dispatch("cart-notice", {
            image: productImage,
            title: productTitle,
            target: form,
            variant: productVariant,
          });
        }

        if (isExpressCheckout) {
          // window.location.href = "https://j-lindeberg-dev.myshopify.com/checkouts";
          document.location.href = "/cart/checkout";
        }

        return response.json();
      })
      .then((response) => {
        const variant = Tracking.transformVariant(response);
        if (variant && Tracking) {
          Tracking.addToCart(variant);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    return false;
  },
  initForm() {
    const form = this.$refs.addToCartForm;
    form.addEventListener("submit", function (event) {
      event.preventDefault();
    });
  },
});
